module.exports = __webpack_public_path__ + "static/fonts/ionicons.dd4781d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/megamenu/fonts/ionicons.ttf
// module id = lnmZ
// module chunks = 0